import { postApi } from './api_instance'

const updateSelectedRegistries = async (formData, logout) => {
  try {
    return await postApi({
      apiUrl: `/admin/projects/api/offsetgo-data`,
      sendToken: true,
      logout,
      data: formData
    })
  } catch (error) {
    throw error
  }
}

export default updateSelectedRegistries
